import useGetData from "../../api/useGetData";
import SelectInput from "../../common/SelectInput";

/**
 * A component that renders a select input with the users created by the agent currently logged. Should be used only when the current user is an agent.
 *
 * @param {Object} props
 * @param {string} props.label - The label shown on top of the select
 * @param {name} props.name - The HTML name of the input
 * @param {Function} props.onChange - A function that runs when the selected value changes
 * @param {string=} props.placeholder - The placeholder to be shown when nothing is selected yet
 * @returns {JSX.Element}
 */

const AgentUserSelect = ({ label, name, onChange, placeholder }) => {
  const { data: agentUsers } = useGetData({
    route: "api/method/airport_transport.api.agent.get_transport_users",
  });
  return (
    <SelectInput
      label={label}
      name={name}
      onChange={onChange}
      options={agentUsers.map((agentUser) => ({
        label: agentUser,
        value: agentUser,
      }))}
      placeholder={placeholder}
    />
  );
};

export default AgentUserSelect;
